export const closeModal = () => {
  const modalElement = window.$('[id^=modal-window]')
  if (!modalElement) return

  modalElement.modal('hide')
}
